<template>
  <div class="module-detail-container">
    <!-- 主内容区 -->
    <div class="module-content">
      <!-- 1. 模块专属图片 -->
      <div class="module-specific-image">
        <img :src="currentModule.url" :alt="currentModule.title" />
      </div>
    </div>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
export default {
  components: {
    bottomUrl,
  },
  data() {
    return {
      // 8个模块的配置数据
      currentModule: {
        title: '市场风控',
        url: require('@/assets/recycling/index/scfk.svg'),
      }
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.module-detail-container {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 90px);
  overflow-y: auto;
  position: relative;
}

.module-content {
  width: 100%;
}

/* 模块专属图片样式 */
.module-specific-image {
  width: 100%;
  display: block;
}

.module-specific-image img {
  width: 100%;
  height: 730px;   
  object-fit: cover;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .module-detail-container {
    height: auto;
  }
  .module-content {
    height: auto;
    padding: 0 16px 180px;
    background-size: 90% auto; /* 移动端适当缩小 */
    
    .module-specific-image .img {
      height: auto !important;
    }
  }
}

</style>
